/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { SHOW_VIDEO_DEBUG_OVERLAY, HIDE_VIDEO_DEBUG_OVERLAY } from './videodebugoverlay.types';

export const showVideoDebugOverlayAction = (): AnyAction => ({
    type: SHOW_VIDEO_DEBUG_OVERLAY,
    payload: {
        isVideoDebugOverlayActive: true,
    },
});

export const hideVideoDebugOverlayAction = (): AnyAction => ({
    type: HIDE_VIDEO_DEBUG_OVERLAY,
    payload: {
        isVideoDebugOverlayActive: false,
    },
});
